import React from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

const AuthWrapper = ({ children }) => {
    const { inProgress } = useMsal();

    const isLoading = inProgress !== InteractionStatus.None;

    if (isLoading) {
        return <div/>;
    }

    // Once MSAL is done initializing (logged in or not), render children
    return <>{children}</>;
};

export default AuthWrapper;
